import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useCognito } from '../hooks/useCognito';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const { logout } = useCognito();
  const navigate = useNavigate();

  useEffect(() => {
    // Esegui il logout dopo un breve delay per mostrare il messaggio
    const timer = setTimeout(() => {
      logout();
    }, 1000);

    return () => clearTimeout(timer);
  }, [logout]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f3f3f3',
        px: 2,
      }}
    >
      <CircularProgress sx={{ mb: 3, color: '#00b6b6' }} />
      <Typography
        variant="h6"
        sx={{
          color: '#607c89',
          fontWeight: 600,
          textAlign: 'center',
          mb: 2,
        }}
      >
        Logging out...
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: '#888',
          textAlign: 'center',
        }}
      >
        You will be redirected to the login page
      </Typography>
    </Box>
  );
} 